// Docs: https://connectrpc.com/docs/introduction

// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file realm/v3/realm.proto (package realm.v3, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_common_v3_common } from "../../common/v3/common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file realm/v3/realm.proto.
 */
export const file_realm_v3_realm: GenFile = /*@__PURE__*/
  fileDesc("ChRyZWFsbS92My9yZWFsbS5wcm90bxIIcmVhbG0udjMixQEKBVJlYWxtEigKCXRlbmFudF9pZBgBIAEoCUIVmrUYEXN0aWQuT3JnYW5pemF0aW9uEi4KD29yZ2FuaXphdGlvbl9pZBgCIAEoCUIVmrUYEXN0aWQuT3JnYW5pemF0aW9uEigKDHdvcmtzcGFjZV9pZBgDIAEoCUISmrUYDnN0aWQuV29ya3NwYWNlEikKCnByb2plY3RfaWQYBCABKAlCEJq1GAxzdGlkLlByb2plY3RIAIgBAUINCgtfcHJvamVjdF9pZCKAAQoOQXZhaWxhYmxlUmVhbG0SHgoFcmVhbG0YASABKAsyDy5yZWFsbS52My5SZWFsbRI2Cg1sYXN0X2FjY2Vzc2VkGAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgAiAEBQhAKDl9sYXN0X2FjY2Vzc2VkSgQIAxALIpgCCg5SZWFsbVdpdGhOYW1lcxIoCgl0ZW5hbnRfaWQYASABKAlCFZq1GBFzdGlkLk9yZ2FuaXphdGlvbhITCgt0ZW5hbnRfbmFtZRgCIAEoCRIuCg9vcmdhbml6YXRpb25faWQYAyABKAlCFZq1GBFzdGlkLk9yZ2FuaXphdGlvbhIZChFvcmdhbml6YXRpb25fbmFtZRgEIAEoCRIoCgx3b3Jrc3BhY2VfaWQYBSABKAlCEpq1GA5zdGlkLldvcmtzcGFjZRIWCg53b3Jrc3BhY2VfbmFtZRgGIAEoCRIkCgpwcm9qZWN0X2lkGAcgASgJQhCatRgMc3RpZC5Qcm9qZWN0EhQKDHByb2plY3RfbmFtZRgIIAEoCSKSAQoXQXZhaWxhYmxlUmVhbG1XaXRoTmFtZXMSJwoFcmVhbG0YASABKAsyGC5yZWFsbS52My5SZWFsbVdpdGhOYW1lcxI2Cg1sYXN0X2FjY2Vzc2VkGAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgAiAEBQhAKDl9sYXN0X2FjY2Vzc2VkSgQIAxALQllaV2dpdGh1Yi5jb20vU3Rvcnl0ZWxsLWFpL3N0b3J5dGVsbC1haS1wbGF0Zm9ybS9wa2cvZ28vZG9tYWlucy9jcC9nZW4vcGIvcmVhbG0vdjM7cmVhbG1WM2IGcHJvdG8z", [file_google_protobuf_timestamp, file_common_v3_common]);

/**
 * The Realm message defines the location of a resource.
 *
 * @generated from message realm.v3.Realm
 */
export type Realm = Message<"realm.v3.Realm"> & {
  /**
   * The tenant_id is a unique identifier for the tenant within the system.
   * Format: ^organization_[a-z0-9]{20}$
   *
   * @generated from field: string tenant_id = 1;
   */
  tenantId: string;

  /**
   * The organization_id is a unique identifier for the organization
   * within the system.
   * Format: ^organization_[a-z0-9]{20}$
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * The workspace_id is a unique identifier for the workspace.
   * Format: ^workspace_[a-z0-9]{20}$
   *
   * @generated from field: string workspace_id = 3;
   */
  workspaceId: string;

  /**
   * The project_id is a unique identifier for the project.
   * Format: ^project_[a-z0-9]{20}$
   *
   * @generated from field: optional string project_id = 4;
   */
  projectId?: string;
};

/**
 * Describes the message realm.v3.Realm.
 * Use `create(RealmSchema)` to create a new message.
 */
export const RealmSchema: GenMessage<Realm> = /*@__PURE__*/
  messageDesc(file_realm_v3_realm, 0);

/**
 * An available realm to the user. Includes a timestamp of when the user
 * last acted within this realm.
 *
 * @generated from message realm.v3.AvailableRealm
 */
export type AvailableRealm = Message<"realm.v3.AvailableRealm"> & {
  /**
   * The realm information.
   *
   * @generated from field: realm.v3.Realm realm = 1;
   */
  realm: Realm;

  /**
   * The timestamp when this realm was last accessed.
   *
   * @generated from field: optional google.protobuf.Timestamp last_accessed = 2;
   */
  lastAccessed: Timestamp;
};

/**
 * Describes the message realm.v3.AvailableRealm.
 * Use `create(AvailableRealmSchema)` to create a new message.
 */
export const AvailableRealmSchema: GenMessage<AvailableRealm> = /*@__PURE__*/
  messageDesc(file_realm_v3_realm, 1);

/**
 * @generated from message realm.v3.RealmWithNames
 */
export type RealmWithNames = Message<"realm.v3.RealmWithNames"> & {
  /**
   * The tenant_id is a unique identifier for the tenant within the system.
   * Format: ^organization_[a-z0-9]{20}$
   *
   * @generated from field: string tenant_id = 1;
   */
  tenantId: string;

  /**
   * The tenant's name
   *
   * @generated from field: string tenant_name = 2;
   */
  tenantName: string;

  /**
   * The organization_id is a unique identifier for the organization
   * within the system.
   * Format: ^organization_[a-z0-9]{20}$
   *
   * @generated from field: string organization_id = 3;
   */
  organizationId: string;

  /**
   * The organization's name
   *
   * @generated from field: string organization_name = 4;
   */
  organizationName: string;

  /**
   * The workspace_id is a unique identifier for the workspace.
   * Format: ^workspace_[a-z0-9]{20}$
   *
   * @generated from field: string workspace_id = 5;
   */
  workspaceId: string;

  /**
   * The work space's name
   *
   * @generated from field: string workspace_name = 6;
   */
  workspaceName: string;

  /**
   * The project_id is a unique identifier for the project.
   * Format: ^project_[a-z0-9]{20}$
   *
   * @generated from field: string project_id = 7;
   */
  projectId: string;

  /**
   * The project's name, only present when project_id is set
   *
   * @generated from field: string project_name = 8;
   */
  projectName: string;
};

/**
 * Describes the message realm.v3.RealmWithNames.
 * Use `create(RealmWithNamesSchema)` to create a new message.
 */
export const RealmWithNamesSchema: GenMessage<RealmWithNames> = /*@__PURE__*/
  messageDesc(file_realm_v3_realm, 2);

/**
 * An available realm to the user. Includes a timestamp of when the user
 * last acted within this realm.
 *
 * @generated from message realm.v3.AvailableRealmWithNames
 */
export type AvailableRealmWithNames = Message<"realm.v3.AvailableRealmWithNames"> & {
  /**
   * The realm information.
   *
   * @generated from field: realm.v3.RealmWithNames realm = 1;
   */
  realm: RealmWithNames;

  /**
   * The timestamp when this realm was last accessed.
   *
   * @generated from field: optional google.protobuf.Timestamp last_accessed = 2;
   */
  lastAccessed: Timestamp;
};

/**
 * Describes the message realm.v3.AvailableRealmWithNames.
 * Use `create(AvailableRealmWithNamesSchema)` to create a new message.
 */
export const AvailableRealmWithNamesSchema: GenMessage<AvailableRealmWithNames> = /*@__PURE__*/
  messageDesc(file_realm_v3_realm, 3);

